// Plan overlay classification — mirrors V1 constants so imports/exports
// round-trip cleanly through the takeoff document.

export const OVERLAY_CATEGORIES = [
  { value: '', label: 'None' },
  { value: 'aerial', label: 'Aerial Image' },
  { value: 'drawing', label: 'Drawing' },
  { value: 'plans', label: 'Plans' },
];

export const OVERLAY_SUB_TYPES = {
  aerial: [
    { value: '', label: 'None' },
    { value: '2025_satellite', label: '2025 Satellite' },
    { value: '2024_satellite', label: '2024 Satellite' },
    { value: '2023_satellite', label: '2023 Satellite' },
    { value: 'drone', label: 'Drone' },
  ],
  drawing: [
    { value: '', label: 'None' },
    { value: 'sketch', label: 'Sketch' },
    { value: 'markup', label: 'Markup' },
  ],
  plans: [
    { value: '', label: 'None' },
    { value: 'landscape', label: 'Landscape' },
    { value: 'irrigation', label: 'Irrigation' },
    { value: 'electrical', label: 'Electrical' },
    { value: 'tree_inventory', label: 'Tree Inventory' },
    { value: 'demo', label: 'Demo' },
    { value: 'grading', label: 'Grading' },
    { value: 'planting', label: 'Planting' },
    { value: 'hardscape', label: 'Hardscape' },
  ],
};
